import { render, staticRenderFns } from "./Best.vue?vue&type=template&id=3a3417a6&"
import script from "./Best.vue?vue&type=script&lang=js&"
export * from "./Best.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports